// import { CartAddEvent, CartUpdateEvent, CartCountEvent, CartErrorEvent } from './events.js';
import {ThemeEvents, CartUpdateEvent, CartCountEvent, QuantitySelectorUpdateEvent} from "@theme/events";
const {cartUpdate: cartUpdate, cartReload: cartReload, cartCount: cartCount, cartError: cartError, currencyUpdate: currencyUpdate, cartDrawerRender: cartDrawerRender, cartMainRender: cartMainRender} = ThemeEvents;
  let limit = 24;
  let totalSelected = 0;
  const variantRadios = document.querySelectorAll('.custom-radio-button');
  variantRadios.forEach((radio) => {
    radio.addEventListener('change', (e) => {
      const quantity = e.target.dataset.quantity;
      console.log('Selected quantity:', quantity);
      limit = quantity;
      document.getElementById('total').innerText = limit;
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-btn');
    const contents = document.querySelectorAll('.tab-content');

    const showTab = (id) => {
      contents.forEach((c) => c.classList.remove('active'));
      tabs.forEach((t) => t.classList.remove('active'));
      document.getElementById(id).classList.add('active');
      document.querySelector(`[data-tab="${id}"]`).classList.add('active');
    };

    tabs.forEach((btn) => {
      btn.addEventListener('click', () => showTab(btn.dataset.tab));
    });

    document.querySelector('.next-btn').addEventListener('click', () => {
      showTab('tab-2');
    });

    document.querySelector('.back-btn').addEventListener('click', () => {
      showTab('tab-1');
    });

    document.querySelector('.finish-btn').addEventListener('click', async () => {
      const selectedVariant = document.querySelector("input[name='variant']:checked")?.value;

      if (!selectedVariant) {
        alert("Choisissez d'abord un coffret");
        return;
      }

      // Collect all selected macarons
      const selectedMacarons = {};
      document.querySelectorAll('.macaron-card').forEach((card) => {
        const qty = parseInt(card.querySelector('.qty').textContent) || 0;
        if (qty > 0) {
          const title = card.querySelector('.macaron-title').textContent.trim();
          selectedMacarons[title] = qty;
        }
      });

      const properties = {
        ...selectedMacarons,
      };

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: selectedVariant,
            quantity: 1,
            properties: properties,
          }),
        });

        const cartData = await response.json();
        console.log(cartData)
        // Dispatch cart events
        const sourceId = 'custom-macaron-picker'; // Any identifier you want
        document.dispatchEvent(new CustomEvent(cartReload));
        document.dispatchEvent(new CustomEvent(cartDrawerRender))
         document.querySelector(
            "hdt-sticky-header > div > div > div.lg\\:hdt-custom-col-5.md\\:hdt-custom-col-4.hdt-custom-col-3 > div > div.hdt-site-nav_icon.hdt-site-nav_cart.hdt-inline-flex.hdt-align-center > a"
            ).click();
        // Redirect to cart page
       // window.location.href = '/cart';
      } catch (error) {
        console.error('Cart add error:', error);
        document.dispatchEvent(new CartErrorEvent('custom-macaron-picker', error.message));
        alert('Failed to add item to cart.');
      }
    });
  });
  const titleText = document.getElementById('tab-title');

  document.querySelectorAll("input[name='variant']").forEach((input) => {
    input.addEventListener('change', () => {
      const selectedLabel = input.closest('.variant-box').querySelector('.v-title').innerText;
      titleText.innerText = selectedLabel;
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.macaron-card').forEach((card) => {
      const addBtn = card.querySelector('.add-btn');
      const counter = card.querySelector('.macaron-counter');
      const qtyBox = card.querySelector('.qty');
      const minus = card.querySelector('.minus');
      const plus = card.querySelector('.plus');

      let qty = 0;

      // Click main image = add 1
      addBtn.addEventListener('click', () => {
        if (totalSelected >= limit) return;
        qty++;
        totalSelected++;
        updateUI();
      });

      plus.addEventListener('click', () => {
        if (totalSelected >= limit) return;
        qty++;
        totalSelected++;
        updateUI();
      });

      minus.addEventListener('click', () => {
        if (qty > 0) {
          qty--;
          totalSelected--;
        }
        updateUI();
      });

      function updateUI() {
        qtyBox.textContent = qty;
        counter.classList.toggle('visible', qty > 0);
        minus.disabled = qty === 0;
        plus.disabled = totalSelected >= limit;
        document.getElementById('selected').innerText = totalSelected;
        if (totalSelected == limit) console.log('Quantity Reached');
      }
    });
  });